document.addEventListener("DOMContentLoaded", function() {  

  document.querySelectorAll('.product-variant').forEach( (e) => {
    e.addEventListener('click', function(){
      
      const variantsMedia = document.querySelectorAll('.product-gallery__media, .product-gallery__thumbnail');
      let $metaimage_found = false, $metaimage_vid, $media_first_main = false, $media_first_thumb = false;
      variantsMedia.forEach((selectors, index) => {
        
        var selVariantId = e.dataset.id;
        /*---- Start Main Gallery ----*/
        if(document.querySelector('.product-gallery__media-list .product-gallery__media')){
          document.querySelectorAll('.product-gallery__media-list .product-gallery__media').forEach(function($media, idx){
            if($media.getAttribute('data-variant')){
              if(parseInt(selVariantId) === parseInt($media.getAttribute('data-variant'))){
                $metaimage_found = true;
                $metaimage_vid = selVariantId;
              }
            }
            var meidaAll =  document.querySelectorAll(".product-gallery__thumbnail:not([hidden='hidden'])")[0];
            
          });
        }
        /*---- End Main Gallery ----*/

        /*---- Start Thumb ----*/
        if(document.querySelector('.product-gallery__thumbnail')){
          document.querySelectorAll('.product-gallery__thumbnail').forEach(function($media, idx){
            if($media.getAttribute('data-variant')){
              if(parseInt(selVariantId) === parseInt($media.getAttribute('data-variant'))){
                $metaimage_found = true;
                $metaimage_vid = selVariantId;
              }
            }
            if(idx === (document.querySelectorAll('.product-gallery__thumbnail').length - 1)){
              if($metaimage_found){
                document.querySelectorAll('.product-gallery__thumbnail').forEach(function($media_show, idx){
                  if(parseInt($media_show.getAttribute('data-variant')) === parseInt($metaimage_vid)){                    
                    $media_show.removeAttribute('hidden');
                    if(!$media_first_thumb){
                      $media_first_thumb = true;
                      $media_show.click();
                      $media_show.dispatchEvent(new Event('click'));
                      $media_show.querySelector('a').classList.add('mz-thumb-selected');
                 
                      var meidaAll =  document.querySelectorAll(".product-gallery__thumbnail:not([hidden='hidden'])")[0];
                      meidaAll.click();
                    }
                  } else{
                    $media_show.setAttribute('hidden', 'hidden');
                    $media_show.querySelector('a').classList.remove('mz-thumb-selected');
                  }
                  if($media_show.getAttribute('data-variant') == 'default'){
                    $media_show.removeAttribute('hidden');
                    if(!$media_first_thumb){
                      $media_first_thumb = true;
                      $media_show.click();
                    }
                  }
                });
              }
            }
        });
      }
      /*---- End Thumb ----*/
        
      });
      
    });
  });

  document.querySelectorAll('.product-gallery__thumbnail').forEach( (thumbList) => {
    thumbList.addEventListener('click', function(){
      setTimeout(function(){
      var thumb_src = thumbList.querySelector('a').getAttribute('href');
      if(document.querySelector('.product-gallery__media[aria-hidden="true"]') != null){
        var media_src = document.querySelector('.product-gallery__media[aria-hidden="true"]').querySelector('a');
        media_src.setAttribute('href',thumb_src);      
        media_src.querySelector('.mz-lens img').setAttribute('src',thumb_src);
        media_src.querySelector('figure > img').setAttribute('src',thumb_src);
      }
      if( document.querySelectorAll('.mz-zoom-window').length > 0){
        document.querySelector('.mz-zoom-window img').src = thumb_src;
      }      
      },900);
      
    });
  });

});
const pdpimage_selector = document.querySelector('#pgmz');

  pdpimage_selector.addEventListener('click', function () {
    setTimeout(function(){
      var mainImg = 'https:'+$('#pgmz').attr('href');
      $('.magic-thumb').removeClass('magic-thumb-selected')
      $('.magic-thumb img[src="'+mainImg+'"]').parent().addClass('magic-thumb-selected')
      $('.mz-expand .mz-figure>img').attr('src',mainImg);    
      MZimage();
    },1000);
  });

// let myEvent = new Event('click');
// pdpimage_selector.dispatchEvent(myEvent);

function MZimage() {
    document.querySelectorAll('.magic-thumb').forEach( el => {
    el.addEventListener('click', function (){
      var mzthumb_src = el.querySelector('img').getAttribute('src'); 
      if(document.querySelector('.product-gallery__media') != null){
        var main_src = document.querySelector('.product-gallery__media').querySelector('a');
        main_src.setAttribute('href',mzthumb_src);  
        if(main_src.querySelector('.mz-lens img') != null){
          main_src.querySelector('.mz-lens img').setAttribute('src',mzthumb_src);
        }
        if(main_src.querySelector('figure > img') != null){
          main_src.querySelector('figure > img').setAttribute('src',mzthumb_src);
        }
      }
    })
  });
}

$(document).ready(function(){
  $('.mz-button-close').click(function(){
    setTimeout(function(){
      changeDiv();
    },1000);
  }); 
  
  document.addEventListener("keydown", ({key}) => {
    if (key === "Escape") {
      setTimeout(function(){
        changeDiv();
      },1000);     
    }
  });

  $('body').click(function(){
    setTimeout(function(){
      changeDiv();
    },1000);     
  });
});

function changeDiv() {
  var mainmediaImg = 'https:'+$('#pgmz').attr('href');
  $('.mz-lens img').attr('src',mainmediaImg);  
}


var x = 1024;
window.addEventListener("resize", reportWindowSize);
window.addEventListener("load", reportWindowSize);
function reportWindowSize() {
  if(window.innerWidth > x){
    var getHeight = document.querySelector('.product__dec-img .relative').clientHeight;
    document.querySelector('.product__dec').style.maxHeight = `${getHeight}px`;
  }else{
    document.querySelector('.product__dec').style.maxHeight = "100%";
  }
}


